import { extractSystemId } from "utils/utils";
import API_URLS from "constants/apis.url";

import { deleteRequest, getRequest, postRequest, putRequest } from "./api";

export const getAlarms = () => getRequest(API_URLS.alarms);

export const getAlarm = (sysId, alarmId) => getRequest(`systems/${sysId}${API_URLS.alarms}/${alarmId}`, false);

export const updateAlarm = async alarmDetails => {
  const { AlarmID, ...payload } = alarmDetails;
  return await putRequest(`${API_URLS.alarms}/${AlarmID}`, payload);
};

export const updateAllAlarms = async updateAllAlarmAlerts => await putRequest(`${API_URLS.allAlarms}`, updateAllAlarmAlerts);

export const setEmailNotificationApi = async emailNotification => await putRequest(`${API_URLS.alarms}`, { emailNotification });

export const toggleAlarmReadStatusApi = async (sysId, alarmId, readAlarm) =>
  await putRequest(`systems/${sysId}${API_URLS.alarms}/${alarmId}/read`, { readAlarm }, true);

export const markAllAlarmsRead = readAlarm => putRequest(`${API_URLS.alarms}/read`, { readAlarm }, true);

export const addAlarm = async payload => {
  const systemId = extractSystemId();
  const URL = `${API_URLS.adminSystemsURL}/${systemId}/add-tag-alarm`;
  return await postRequest(URL, payload, true);
};

export const deleteAlarmApi = async alarmId => {
  const systemId = extractSystemId();
  const URL = `${API_URLS.adminSystemsURL}/${systemId}/delete-tag-alarm/${alarmId}`;
  return await deleteRequest(URL, {}, true);
};
